/*
 * Product card ribbon badges — cards whose product-tags metafield has more
 * than one value render every tag inside [data-dc-badges] (see
 * snippets/orizza-discover-card.liquid and frost-discover-card.liquid).
 * One page-wide timer moves .is-active to the next ribbon in each set; the
 * slide out / slide in itself is a CSS transition (section-*-pdp-discover.css).
 * Querying on every tick also picks up cards added later (recently viewed,
 * infinite scroll) without any re-initialising.
 */
(function () {
  if (window.__dcBadgeRotate) return;
  window.__dcBadgeRotate = true;

  // Reduced motion: the first tag stays put.
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  setInterval(function () {
    if (document.hidden) return;
    document.querySelectorAll('[data-dc-badges]').forEach(function (set) {
      var items = set.children;
      if (items.length < 2) return;
      var current = set.querySelector('.is-active');
      var index = Array.prototype.indexOf.call(items, current);
      if (current) current.classList.remove('is-active');
      items[(index + 1) % items.length].classList.add('is-active');
    });
  }, 2800);
})();
